import {
  ChangeDetectionStrategy,
  Component, HostBinding, HostListener,
  Input
} from "@angular/core";

@Component({
  selector: 'int-text-expander',
  template: `
    <span>
      <button
        int-bordered-button
        mode="success"
        size="sm"
        (click)="toggle($event)"
      >
        <int-icon [name]="iconName" size="1rem"></int-icon>
      </button>
    </span>
    <int-empty-divider size="0.5rem"></int-empty-divider>
    <span class="int-t-content" #text>
      {{ (content || '') | intTextClamp:maxCharsAmount:!showFull }}
    </span>
  `,
  styles: [`
    :host {
      display: flex;
      align-items: center;
      --int-bordered-button-padding: 0.3rem;
      cursor: pointer;
    }
    :host._is-break .int-t-content {
      word-break: break-all;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntTextExpanderComponent {
  @Input() showFull = false;
  @Input() maxCharsAmount = 30;
  @Input() content: string | null = '';
  @Input() breakWords: boolean = true;

  get iconName() {
    return this.showFull ? 'minimize' : 'maximize'
  }

  @HostBinding('class._is-break') get isBreak() {
    return this.breakWords;
  }

  @HostListener('click', ['$event']) _toggle(e: Event) {
    this.toggle(e);
  }

  toggle(e: Event) {
    e.stopPropagation();
    e.preventDefault();
    this.showFull = !this.showFull;
  }
}
